import axiosClientFSR from "../axiosClientFSR";

export const companyFSR = {
    get: (param) => {
        return axiosClientFSR.get('/camaiservice/company/get-list-company', {
            params: param
        })
    },
}